import { versementService } from '../../services'

const initialState = { loading: true, data: null, error: null, totalItems: null, totalPages: null, page: null }

export const versement = {
    namespaced: true,
    state: initialState,
    getters: {
        versements: (state) => {
            return state
        }
    },
    actions: {
        getAll ({ commit }) {
            commit('getAllRequest')

            versementService.getAll()
                .then(
                    data => {
                        commit('getAllSuccess', data)
                    },
                    error => {
                        commit('getAllFailure', error)
                    }
                )
        },
        getForUser ({ commit }, { userId, utamId, page= null,numberItem, sortBy = null, sortOrder = null }) {
            commit('getForUserRequest')
            return new Promise((resolve, reject) => {
                versementService.getForUser(utamId, userId,numberItem,page, sortBy, sortOrder)
                    .then(
                        response => {
                            commit('getForUserSuccess', response)
                            resolve(response)
                        },
                        error => {
                            commit('getForUserFailure', error)
                            reject(error)
                        }
                    )
            })
        },
        getForUtam({ commit }, { utamId, numberItem, page = null, sortBy = null, sortOrder = null }) {
            commit('getForUtamRequest');

            return versementService
                .getForUtam(utamId, numberItem, page, sortBy, sortOrder)
                .then(response => {
                    commit('getForUtamSuccess', response);
                    return response;
                })
                .catch(error => {
                    commit('getForUtamFailure', error);
                    throw error;
                });
        }

    },
    mutations: {
        getAllRequest (state) {
            state.loading = true
            state.error = null
        },
        getAllSuccess (state, data) {
            state.loading = false
            state.data = data.sort((a, b) => new Date(b.dateVersement) - new Date(a.dateVersement))
            state.error = null
        },
        getAllFailure (state, error) {
            state.loading = false
            state.data = null
            state.error = error
        },
        getForUserRequest (state) {
            state.loading = true
            state.error = null
        },
        getForUserSuccess (state, response) {
            state.loading = false
            state.data = response.data
            state.totalItems= response.totalItems
            state.totalPages= response.totalPages
            state.page= response.page
            state.error = null
        },
        getForUserFailure (state, error) {
            state.loading = false
            state.data = null
            state.error = error
        },
        getForUtamRequest (state) {
            state.loading = true
            state.error = null
        },
        getForUtamSuccess (state, response) {
            state.loading = false
            state.data = response.data
            state.totalItems= response.totalItems
            state.totalPages= response.totalPages
            state.page= response.page
            state.error = null
        },
        getForUtamFailure (state, error) {
            state.loading = false
            state.data = null
            state.error = error
        }
    }
}
